query Tests(
	$offset: Int!
	$limit: Int!
	$textSearch: wsdk_test_runsSearchInsensitive
	$sort: wsdk_test_runsSort
	$daysAmountFilter: ConditionInt
	$propertiesFilter: ConditionID
	$customFieldsFilter: ConditionStringArray
	$andFilter: [wsdk_test_runsAndFilter!]
) {
	wsdk_test_runs(
		text_contains: $textSearch
		offset: $offset
		limit: $limit
		sort: $sort
		run_time_last_n_days: $daysAmountFilter
		property_ids_eq_any_item: $propertiesFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		and: $andFilter
	) {
		run_id
		test_name
		total_issues
		critical_issues
		run_time
		custom_fields
		environments
		flows
		test_path
		property_ids
	}
	total: wsdk_test_runs(
		text_contains: $textSearch
		run_time_last_n_days: $daysAmountFilter
		property_ids_eq_any_item: $propertiesFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		and: $andFilter
	) {
		run_id_count
	}
	unfiltered_total: wsdk_test_runs {
		run_id_count
	}
}

query RecentTests(
	$offset: Int!
	$limit: Int!
	$textSearch: wsdk_latest_test_runsSearchInsensitive
	$sort: wsdk_latest_test_runsSort
	$daysAmountFilter: ConditionInt
	$propertiesFilter: ConditionID
	$customFieldsFilter: ConditionStringArray
	$andFilter: [wsdk_latest_test_runsAndFilter!]
) {
	wsdk_test_runs: wsdk_latest_test_runs(
		text_contains: $textSearch
		offset: $offset
		limit: $limit
		sort: $sort
		run_time_last_n_days: $daysAmountFilter
		property_ids_eq_any_item: $propertiesFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		and: $andFilter
	) {
		run_id
		test_name
		total_issues
		critical_issues
		run_time
		custom_fields
		environments
		flows
		test_path
		property_ids
	}
	total: wsdk_latest_test_runs(
		text_contains: $textSearch
		run_time_last_n_days: $daysAmountFilter
		property_ids_eq_any_item: $propertiesFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		and: $andFilter
	) {
		run_id_count
	}
	unfiltered_total: wsdk_test_runs {
		run_id_count
	}
}
